import { DateTimePicker } from "designSystem/index";
import React from "react";

export default () => {
	const onChangeValue = (date) => {
		alert(date);
	};

	return (
		<DateTimePicker onChange={onChangeValue} />
	);
};